import React, { type Dispatch, type SetStateAction } from "react";

import { IconFullscreen } from "@synthesis/shared-icons";
import { getApiBaseUrl } from "@synthesis/shared-services";
import { Modal, useManualModalState } from "@synthesis/shared-ui";

import { saveModelIdsAtRedis } from "../../../api";
import { useStores } from "../../../store";

interface AddModalPreviewProps {
  modelId?: string;
  compare?: boolean;
}

interface ModalPreviewProps extends AddModalPreviewProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

const ModalPreview = React.memo((props: ModalPreviewProps) => {
  const { modelId, compare } = props;
  return (
    <Modal.Root manual {...props}>
      <AddModalPreview modelId={modelId} compare={compare} />
    </Modal.Root>
  );
});

const AddModalPreview = React.memo(({ modelId, compare }: AddModalPreviewProps) => {
  const { generalStore } = useStores();
  const [url, setUrl] = React.useState<string>("");

  React.useEffect(() => {
    if (!modelId || !generalStore.projectId) return;

    (async () => {
      const modelsId = modelId.split(",");

      if (compare) {
        setUrl(`${getApiBaseUrl()}/viewer/#/${generalStore.projectId}/compare?current=${modelsId[0]}&old=${modelsId[1]}`);
        return;
      }

      const generateModelId = (await saveModelIdsAtRedis({ body: { modelIds: modelsId } })).data;
      setUrl(`${getApiBaseUrl()}/viewer/#/${generalStore.projectId}?models=${generateModelId}`);
    })();
  }, [modelId, generalStore.projectId, compare]);

  const { closeModal } = useManualModalState();

  return (
    <Modal.Content className="z-50 h-[85%] w-full">
      <Modal.Title>Просмотр модели</Modal.Title>
      {[
        {
          handleClick: () => {
            window.open(url, "_blank")?.focus();
            closeModal();
          },
          element: <IconFullscreen className="text-type-light size-5" />,
        },
      ]?.map(({ handleClick, element }, i) => (
        <figure
          key={i}
          className="absolute right-[35px] top-[12px] z-10 h-5 cursor-pointer items-center px-4 text-black transition-all duration-150"
          onClick={handleClick}
        >
          {element}
        </figure>
      ))}
      <iframe title="Model preview" width="100%" height="100%" src={url} sandbox="allow-scripts" />
    </Modal.Content>
  );
});

export default ModalPreview;
